import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class SwymButton extends HTMLElement {
    connectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSwymButton);
    }

    disconnectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSwymButton);
    }

    /**
     * Updates the swym button
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    updateSwymButton = (event) => {

        const newButton = event.detail.data.html.querySelector('swym-button [ref="swymButtonContainer"]');
        const button = this.querySelector('[ref="swymButtonContainer"]');

        if (!newButton || !button) return;

        button.innerHTML = newButton.innerHTML

        if (typeof window.customInitSwym !== 'undefined') {
            window.customInitSwym();
        }

    };
}

if (!customElements.get('swym-button')) {
    customElements.define('swym-button', SwymButton);
}
